'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

interface NavItem {
  label: string;
  href:  string;
}

interface NavigationProps {
  locale:    string;
  items:     NavItem[];
  mobile?:   boolean;
  onSelect?: () => void;
}

export function Navigation({ locale, items, mobile = false, onSelect }: NavigationProps) {
  const pathname = usePathname();

  const isActive = (href: string) => {
    if (href === `/${locale}`) return pathname === `/${locale}` || pathname === `/${locale}/`;
    return pathname.startsWith(href);
  };

  if (mobile) {
    return (
      <nav aria-label="Mobile navigation">
        <ul className="flex flex-col gap-1">
          {items.map((item) => {
            const active = isActive(item.href);
            return (
              <li key={item.href}>
                <Link
                  href={item.href}
                  onClick={onSelect}
                  aria-current={active ? 'page' : undefined}
                  className={[
                    'flex items-center px-4 py-3 rounded-lg text-sm font-medium',
                    'transition-colors duration-180',
                    active
                      ? 'bg-primary-500/10 text-primary-500'
                      : 'text-(--text) hover:bg-(--surface) hover:text-primary-500',
                  ].join(' ')}
                >
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }

  return (
    <nav aria-label="Main navigation">
      <ul className="flex items-center gap-1">
        {items.map((item) => {
          const active = isActive(item.href);
          return (
            <li key={item.href}>
              <Link
                href={item.href}
                aria-current={active ? 'page' : undefined}
                className={[
                  'relative px-3 py-1.5 rounded-md text-sm font-medium',
                  'transition-colors duration-180',
                  active
                    ? 'text-primary-500'
                    : 'text-(--muted) hover:text-(--text)',
                ].join(' ')}
              >
                {item.label}
                {/* {active && (
                  <span
                    aria-hidden="true"
                    className="absolute inset-x-3 -bottom-px h-px bg-primary-500 rounded-full"
                  />
                )} */}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default Navigation;
